import { AppAreaConfig } from '@/funnels/@types'
import maleTaiChiYogaPr from './activity-male-tai-chi-yoga-pr'
import femaleTaiChi from './activity-female-tai-chi'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-tai-chi-pr',
	options: {
		userTags: ['tai_chi_walking'],
		userFlags: ['hasAccessToWalkingVideos'],
	},
	landing: {
		ids: ['loader-tai-chi', 'age-tai-chi-pr'],
		route: {
			path: '/tai-chi-pr',
			name: 'main-tai-chi-pr-funnel',
		},
	},
	funnel: {
		id: 'ob-tai-chi-gender-selection-pr',
		route: {
			path: '/tai-chi-pr/ob/:page(.*)?',
			name: 'main-tai-chi-pr',
		},
		slug: 'main-tai-chi-pr',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
		redirectTo: {
			sex: {
				male: { appArea: maleTaiChiYogaPr },
				female: { appArea: femaleTaiChi },
			},
		},
	},
}

export default appAreaConfig
